export const projectDetailRoutes = [
  '/executive_summary',
  '/ghg_rating',
  '/sdg_rating',
  '/esr_rating',
  '/project_comparison',
  '/related_content',
];
